
import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './components/Login';
import AdminRoutes from './routes/AdminRoutes';
import ClientRoutes from './routes/ClientRoutes';
import EmployeeRoutes from './routes/EmployeeRoutes';
import CandidateRoutes from './routes/CandidateRoutes';
import ConfirmAccount from './components/ClientModule/ConfirmAccount';
import ServiceDown from './components/service-down/ServiceDown';
import CandidateDashboard from "./components/candidate/CandidateDashboard/candidate-Dashboard";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/confirm-account" element={<ConfirmAccount />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/client/*" element={<ClientRoutes />} />
        <Route path="/employee/*" element={<EmployeeRoutes />} />
        <Route path="/candidate/*" element={<CandidateRoutes />} />
        <Route path="/service-down/:service" element={<ServiceDown />} />
        <Route path="/client/dashboard/:candidateId" element={<CandidateDashboard />} />
        <Route path="/dashboard" element={<Login />} />
        {/* Catch-all route for invalid paths */}
        <Route path="*" element={<ServiceDown />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Router>
  );
}

export default App;
